<template>
    <div>
        <div style="text-align: center">
            <h3>Tambah Group WhatsApp</h3>
        </div>
            <div class="tab-wrapper">
                <div class="tab-content">
                        <form action="" method="post">
                            <label for="">Device*</label>
                            <select v-model="importGroup.device" class="form-control" :disabled="importGroup.step != 1" required>
                                <option value="" selected disabled>== PILIH DEVICE ==</option>
                                <option v-for="d in device" :key="d.id" :value="d.id">
                                    {{ d.name + " (" + d.status + ")"}}</option>
                            </select>
                            <br />
                            <div v-if="importGroup.step == 1">
                                <button v-if="importGroup.loading"
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                    disabled>
                                    <div class="spinner-border spinner" role="status"></div>
                                    Loading
                                </button>
                                <button v-else type="button" class="btn btn-primary btn-block" v-on:click="loadDeviceGroup">
                                    Selanjutnya
                                </button>
                            </div>
                            <div v-else>
                                <label for="">Group*</label>
                                <!-- <select v-model="importGroup.selectedGroup" class="form-control">
                                    <option :value="null_value" selected disabled>
                                        == PILIH GROUP ==
                                    </option>
                                    <option v-for="option in importGroup.loadedGroup" :key="option.id" :value="option.id">{{ option.name }}
                                        [ID: {{ option.id }}]</option>
                                </select> -->
                                <multiselect v-model="importGroup.selectedGroup" tag-placeholder="Cari group"
                                    placeholder="Cari group atau kontak" label="name" track-by="id" :options="importGroup.loadedGroup"
                                    :multiple="true" :internal-search="true" ref="selectedItemsGroup">
                                    <template slot="beforeList">
                                        <div>
                                            <label @click="selectNoneGroup" class="selectAll">Deselect All</label>
                                            <label @click="selectAllGroup" class="selectAll">Select All</label>
                                        </div>
                                    </template>
                                </multiselect>
                                <br />
                                <label>Masukkan Whatsapp Group Ke Group Kontak</label>
                                <multiselect v-model="selectedGroupForImport" placeholder="Cari group" label="name" track-by="id" 
                                    :options="groupdd" :multiple="false" :allow-empty="true" :show-labels="false"
                                    @input="updateImportGroup">
                                    <template slot="singleLabel" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                </multiselect>
                                <br />
                                <button v-if="importGroup.loading"
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                    disabled>
                                    <div class="spinner-border spinner" role="status"></div>
                                    Loading
                                </button>
                                <button v-else type="button" class="btn btn-primary btn-block" v-on:click="addGroup">
                                    Tambahkan
                                </button>
                                <button class="btn btn-danger btn-block" v-on:click="cancelImportGroup">
                                    Batal
                                </button>
                            </div>
                        </form>
                    </div>
                    </div>
                    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    export default {
        props: ["groupdd"],
        components: {
            Multiselect
        },
        data() {
            return {
                inputCari:"",
				placeCari:"Search Group ....",
                page: {
                    one: true,
                    two: false,
                    three: false
                },
                importData: [],
                form: {
                    name: "",
                    number: "",
                    variable: [],
                    group: null,
                },
                null_value: null,
                csvParseLoading: false,
                csvImportReady: false,
                device: [],
                importContact: {
                    loading: false,
                    device: "",
                    group: null
                },
                importGroup: {
                    step: 1,
                    loading: false,
                    device: "",
                    loadedGroup: [],
                    selectedGroup: null,
                    group: null
                },
                selectedGroupForImport: null
            };
        },
        mounted() {
            this.getDevice()
        },
        methods: {
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
            async loadDeviceGroup() {
                if(!this.importGroup.device){
                    this.$toast.error("Silahkan pilih device terlebih dahulu") 
                    return
                }

                this.importGroup.loading = true
                let res = await this.$store.dispatch("contact_load_group_device", {
                    id: parseInt(this.importGroup.device)
                });
                
                this.importGroup.loadedGroup = res.data.data.groups

                this.importGroup.step++
                this.importGroup.loading = false
            },
            async cancelImportGroup(){
                this.importGroup.device = ""
                this.importGroup.step--
            },
            async addGroup() {
                this.importGroup.loading = true
                try {
                    let selectedGroup = this.importGroup.selectedGroup.map(group => {
                        return {
                            name: "[WHATSAPP GROUP] " + group.name,
                            number: group.id
                        }
                    })
                    let response = await this.$store.dispatch("contact_create_bulk", {
                        group: this.importGroup.group,
                        data: selectedGroup
                    });
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "new_wg_group");
                    this.$root.$emit("refresh_table", true);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
                this.importGroup.loading = false
            },
            selectNoneGroup() {
                this.importGroup.selectedGroup = null
            },
            selectAllGroup() {
                this.importGroup.selectedGroup = this.importGroup.loadedGroup
            },
            updateImportGroup(option) {
                this.importGroup.group = option ? option.id : null
            }
        },
    };
</script>

<style scoped>
    #ulCari{border:1px solid #CCC;padding:10px;margin-top:10px;border-radius:5px}
    #ulCari li{padding:3px;border-radius:5px}
	#ulCari li:hover{background:#337aff;color:white}
    .spinner {
        height: 1rem !important;
        width: 1rem !important;
    }

    .btn-spinner {
        line-height: 1rem !important;
    }

    .nav-link {
        cursor: pointer !important;
    }
</style>

<style scoped>
    .thick-border {
        border: 2px solid #6c6c6c !important;
    }

    .selectAll {
        display: inline-block;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
        padding: 0.5rem 1rem;
        border: 1px solid #e5e7eb;
        border-radius: 0.5rem;
        background-color: #ffffff;
        color: #374151;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        user-select: none;
    }

    .selectAll:hover {
        background-color: #10b981;
        color: white;
        border-color: #10b981;
        box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.3), 0 2px 4px -1px rgba(16, 185, 129, 0.2);
        transform: translateY(-1px);
    }

    .selectAll:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px 0 rgba(16, 185, 129, 0.2);
    }
</style>